import { ConfirmDialog, DialogFooter, DialogHeader } from "@/ds";
import styles from "./confirmar-situacao-dialog.module.scss";
import type { ConfirmarSituacaoDialogViewModel } from "./types-confirmar-situacao-dialog";

export function ConfirmarSituacaoDialogView({
  tom,
  titulo,
  subtitulo,
  oQueAcontece,
  tituloEfeitos,
  corpo,
  campos,
  confirmarLabel,
  erro,
  isSubmitting,
  confirmar,
  cancelar,
}: ConfirmarSituacaoDialogViewModel) {
  return (
    <ConfirmDialog
      visible
      testId="confirmar-situacao"
      onHide={cancelar}
      closable={!isSubmitting}
      closeOnEscape={!isSubmitting}
      header={<DialogHeader icon="power-off" tone={tom} title={titulo} subtitle={subtitulo} />}
      message={
        <div className={styles.corpo}>
          {corpo ? <div data-testid="confirmar-situacao-corpo">{corpo}</div> : null}
          <section className={styles.bloco} data-testid="confirmar-situacao-efeitos">
            <h3 className={styles.blocoTitulo}>{tituloEfeitos}</h3>
            <ul className={styles.lista}>
              {oQueAcontece.map((efeito) => (
                <li key={efeito}>{efeito}</li>
              ))}
            </ul>
          </section>
          {campos ? <div data-testid="confirmar-situacao-campos">{campos}</div> : null}
          {erro ? (
            <p role="alert" className={styles.erro} data-testid="confirmar-situacao-erro">
              {erro}
            </p>
          ) : null}
        </div>
      }
      footer={
        <DialogFooter
          cancelVariant="text"
          testId="confirmar-situacao"
          confirmLabel={confirmarLabel}
          severity={tom === "danger" ? "danger" : undefined}
          cancelButtonProps={{ autoFocus: true }}
          confirmButtonProps={tom === "success" ? { severity: "success" } : undefined}
          loading={isSubmitting}
          locked={isSubmitting}
          onConfirm={confirmar}
          onCancel={cancelar}
        />
      }
    />
  );
}
